import React from 'react';
import styles from './index.module.less';
import ModelTitle from 'components/ModelTitle';
import env1 from '@/public/images/env1.png';
import env2 from '@/public/images/env2.png';
import env3 from '@/public/images/env3.png';
import Image from 'next/image';

const Index: React.FC = () => {
  // 环境介绍数据
  const descAll = [
    {
      title: '能量充电站',
      desc: '为守护大家的职场健康，公司为员工在休息区提供了睡眠舱&按摩椅',
    },
    {
      title: '舌尖上的办公室',
      desc: '为帮助大家在工作中补充能量，各个楼层都会提供免费的饮料和零食',
    },
    {
      title: '宠物治愈时刻',
      desc: '公司有猫房，面向全体员工开放，营造更温暖有爱的办公氛围',
    },
  ];

  return (
    <div className={styles.mj_env_container}>
      <ModelTitle title="公司环境" type="env" />
      <div className={styles.mj_env_picAll}>
        <div className={styles.mj_env_picL}>
          <Image src={env1} alt="" draggable={false} />
        </div>
        <div className={styles.mj_env_picR}>
          <Image src={env2} alt="" draggable={false} />
          <Image src={env3} alt="" draggable={false} />
        </div>
      </div>
      <div className={styles.mj_env_descAll}>
        {descAll?.map((item, index) => {
          return (
            <div className={styles.mj_env_desc_item} key={index}>
              <div className={styles.mj_env_desc_item_title}>{item.title}</div>
              <div className={styles.mj_env_desc_item_desc}>{item.desc}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Index;
